module.exports = __webpack_public_path__ + "static/media/345GriffinStNW_2018-06-05_51.bcb6be52.jpg";